export const serverDriveSharingLink = () => window.getDriveSharingLink?.()
export const serverDriveLink = () => window.getDriveLink?.()
export const serverDriveFileRequestId = () => window.getDriveFileRequestId?.()
export const serverDriveFileId = () => window.getDriveFileId?.()
export const serverDriveRootFileList = () => window.getDriveRootFileList?.()
export const serverDriveTexts = () => window.getDriveTexts?.()
export const serverDriveFileRequestExpire = () => window.getDriveFileRequestExpire?.()
export const serverDriveFileRequestIdentifier = () => window.getDriveFileRequestIdentifier?.()
export const serverDriveFileRequestDescription = () => window.getDriveFileRequestDescription?.()
export const serverDriveFileRequestTitle = () => window.getDriveFileRequestTitle?.()
export const serverDriveFileRequestCreator = () => window.getDriveFileRequestCreator?.()
export const serverDriveFileRequestHasDueDateHour = () => window.getDriveFileRequestHasDueDateHour?.()
export const serverOfficeTexts = () => window.getOfficeTexts?.()
export const serverDSID = () => window.getDriveDSID?.()
export const serverDriveFileRequestState = () => window.getDriveFileRequestState?.()

const serverInject = {
  serverDriveSharingLink,
  serverDriveLink,
  serverDriveFileRequestId,
  serverDriveFileId,
  serverDriveRootFileList,
  serverDriveTexts,
  serverDriveFileRequestExpire,
  serverDriveFileRequestIdentifier,
  serverDriveFileRequestDescription,
  serverDriveFileRequestTitle,
  serverDriveFileRequestCreator,
  serverDriveFileRequestHasDueDateHour,
  serverOfficeTexts,
  serverDSID,
  serverDriveFileRequestState,
}

export default serverInject
